import { useMemo } from 'react';
import { WayfindingTabCards as WayfindingTabCards$1, Div, TabCard, CMSContent } from '@cbhq/cdx-components';
import { jsx, jsxs } from 'react/jsx-runtime';
const TAB_CARDS_CONTENT_MODEL_ID = 'cdxTabCards';
function WayfindingTabCards({
  tabCards = [],
  eyebrow,
  headline,
  anchor = 'tab-cards',
  style
}) {
  // CDS Tabs expects an id and label.  We'll use index as id to match card children
  const tabs = useMemo(() => {
    return tabCards.map((tab, i) => {
      return {
        label: tab?.fields?.label,
        id: i.toString()
      };
    });
  }, [tabCards]);
  return /*#__PURE__*/jsx(WayfindingTabCards$1, {
    tabs: tabs,
    headline: headline,
    eyebrow: eyebrow,
    anchor: anchor,
    style: style,
    children: tabCards && tabCards.map((card, i) => {
      const navLink = card.fields?.link?.fields?.url;
      const navLinkLabel = card.fields?.link?.fields?.label;
      return /*#__PURE__*/jsx(Div, {
        flexDirection: "column",
        spacingTop: 7,
        children: /*#__PURE__*/jsxs(TabCard, {
          navLink: navLink,
          navLinkLabel: navLinkLabel,
          style: style,
          children: [/*#__PURE__*/jsx(CMSContent, {
            content: card.fields.content?.[0],
            additionalProps: {
              as: 'div',
              aspectRatio: 'square',
              hasSpacingHorizontal: false,
              hasSpacingTop: false,
              style
            }
          }), /*#__PURE__*/jsx(CMSContent, {
            content: card.fields.content?.slice(1),
            additionalProps: {
              as: 'div',
              aspectRatio: 'square',
              hasSpacingHorizontal: false,
              hasSpacingTop: true,
              style
            }
          })]
        })
      }, i);
    })
  });
}
export { TAB_CARDS_CONTENT_MODEL_ID, WayfindingTabCards };
//# sourceMappingURL=WayfindingTabCards.js.map
